import { useEffect, useState } from "react";
import { listEvalDatasets } from "../../utils/evaluation-functions";
import Sidebar from "../Sidebar";
import CreateDataset from "./CreateDataset";
import DatasetsList from "./DatasetsList";

export default function Evaluation({ setAuth, setUserOrg, userId }) {
  const [datasets, setDatasets] = useState(null);
  const [activeTab, setActiveTab] = useState("create");

  const refreshDatasets = async () => {
    try {
      const all = await listEvalDatasets();
      setDatasets(all || []);
    } catch (error) {
      console.error("Failed to list eval datasets:", error);
      setDatasets([]);
    }
  };

  useEffect(() => {
    refreshDatasets();
    const intervalId = setInterval(refreshDatasets, 15000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="h-[100dvh]">
        <div className="flex h-[100%] fixed top-0">
          <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
        </div>
      </div>
      <div
        className="flex flex-col w-full"
        style={{
          marginLeft: "var(--sidebar-width, 250px)",
          width: "calc(100% - var(--sidebar-width, 250px))",
        }}
      >
        <header className="bg-white shadow-sm p-4 flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="font-bold text-[28px] text-ktx-purple">
              AI Model Evaluation
            </h1>
          </div>
        </header>

        <div className="flex border-b border-gray-200 bg-white">
          <button
            onClick={() => setActiveTab("create")}
            className={`py-4 px-8 font-medium text-lg ${
              activeTab === "create"
                ? "border-b-2 border-ktx-purple text-ktx-purple"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Create Dataset
            </div>
          </button>
          <button
            onClick={() => setActiveTab("view")}
            className={`py-4 px-8 font-medium text-lg ${
              activeTab === "view"
                ? "border-b-2 border-ktx-purple text-ktx-purple"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
                <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
                <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
              </svg>
              View Datasets
            </div>
          </button>
        </div>

        <div className="flex-1 p-6 max-w-6xl mx-auto w-full">
          {activeTab === "create" ? (
            <CreateDataset
              userId={userId}
              onCreated={() => {
                refreshDatasets();
                setActiveTab("view");
              }}
            />
          ) : (
            <DatasetsList datasets={datasets} onChanged={refreshDatasets} />
          )}
        </div>
      </div>
    </div>
  );
}
